import React, { useState } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import {
  NamedLink,
  FieldTextInput,
  Button,
  ExternalLink,
  LayoutComposer,
  H3,
} from '../../components';

import StaticPage from '../PageBuilder/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './ContactUsPage.module.css';
import { handleSubmit } from '../ListingPage/ListingPage.shared';

const ContactUsPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const layoutAreas = `
    topbar
    main
    footer
  `;

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleMessageChange = event => {
    setMessage(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // API endpoint where you handle sending emails
      const response = await axios.post('/api/sendEmail', { name, email, message });
      console.log('Email sent successfully:', response.data);
      setName(''); // Clear name on success
      setEmail(''); // Clear email on success
      setMessage(''); // Clear message on success
      setSuccessMessage('Thank you for your email!'); // Clear success message if there's an error
    } catch (error) {
      console.error('Failed to send email:', error);
      setError('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <StaticPage
      className={css.root}
      title="Contact Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactUsPage',
        description: 'Contact us page',
        name: 'Contact us page',
      }}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {() => (
          <>
            <TopbarContainer />
            <div className={css.content}>
              <div className={css.headingContainer}>
                <H3 as="h1" className={css.heading}>
                  Contact Us
                </H3>
              </div>
              <form onSubmit={handleSubmit}>
                <input
                  className={css.inputField}
                  type="text"
                  placeholder="Your Name"
                  value={name}
                  onChange={handleNameChange}
                  disabled={isSubmitting}
                />
                <input
                  className={css.inputField}
                  type="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={handleEmailChange}
                  disabled={isSubmitting}
                />
                <textarea
                  className={css.messageBox}
                  placeholder='Type your message here...'
                  value={message}
                  onChange={handleMessageChange}
                  disabled={isSubmitting}
                />
                <br/>
                <Button type="submit" disabled={isSubmitting || !name.trim() || !email.trim() || !message.trim()}>
                  Send Message
                </Button>
              </form>
              {successMessage && <div className={css.success}>{successMessage}</div>}
              {error && <div className={css.error}>{error}</div>}
            </div>
            <FooterContainer />
          </>
        )}
      </LayoutComposer>
    </StaticPage>
  );
};

export default ContactUsPage;